/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Accounts object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Accounts = {
	stored: [],
	get: function (accounts, cb) {
		Api.get('/accounts', {accounts: accounts}, function (data) {
			for (var i in data) {
				Accounts.stored[data[i].id] = data[i];
			}
			cb();
		});
	},
	getIfNot: function (data, cb) {
		var accounts_ = [];
		for (var i = 0; i < data.length; i++) {
			if (!Accounts.stored[data[i]])
				accounts_.push(data[i]);
			if (i == (data.length - 1)) {
				if (accounts_.length > 0)
					Accounts.get(accounts_, cb);
				else
					cb();
			}
		}
		
	},
	getByAccountIfNot: function (data, cb) {
		var accounts_ = [];
		for (var i = 0; i < data.length; i++) {
			if (!Accounts.stored[data[i].account.id])
				accounts_.push(data[i].account.id);
			if (i == (data.length - 1)) {
				if (accounts_.length > 0)
					Accounts.get(accounts_, cb);
				else
					cb();
			}
		}
	}
};

var accounts = Accounts.stored;